var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddressPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 11.3681C16.602 11.9583 18.7 13.3063 18.7 14.8748C18.7 16.9873 14.8944 18.6998 10.2 18.6998C5.50553 18.6998 1.69995 16.9873 1.69995 14.8748C1.69995 13.3063 3.79791 11.9583 6.79995 11.3681M10.2 14.4498V7.64981M10.2 7.64981C11.6083 7.64981 12.75 6.50813 12.75 5.09981C12.75 3.69148 11.6083 2.5498 10.2 2.5498C8.79163 2.5498 7.64995 3.69148 7.64995 5.09981C7.64995 6.50813 8.79163 7.64981 10.2 7.64981Z",
    stroke: "#142C4B",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressPin);
export default __webpack_public_path__ + "static/media/address-pin.2c85a539f92bb167f0c7b6b8d89ac3b2.svg";
export { ForwardRef as ReactComponent };